// Template/marker parsing — ported from web_claude (kept behaviorally identical).
// fill_blank and word_bank_fill both encode blanks inline as *answer* markers
// (fill_blank also supports *ans|alt1|alt2* pipe alternatives).

export function parseFillBlankData(interaction) {
  const source = (interaction.prompt || "").trim();
  const markerRegex = /\*([^*]+)\*/g;
  const parts = [];
  const blanks = [];

  let cursor = 0;
  let blankIndex = 0;
  let match;

  while ((match = markerRegex.exec(source)) !== null) {
    const full = match[0];
    const content = (match[1] || "").trim();
    const index = match.index || 0;

    if (index > cursor) {
      parts.push({ type: "text", value: source.slice(cursor, index) });
    }

    const answers = content
      .split("|")
      .map((v) => v.trim())
      .filter(Boolean);

    if (answers.length > 0) {
      blanks.push(answers);
      parts.push({ type: "blank", blankIndex });
      blankIndex += 1;
    } else {
      parts.push({ type: "text", value: full });
    }

    cursor = index + full.length;
  }

  if (cursor < source.length) {
    parts.push({ type: "text", value: source.slice(cursor) });
  }
  if (parts.length === 0) {
    parts.push({ type: "text", value: source });
  }

  return { parts, blanks };
}

export function parseWordBankTemplate(template) {
  const t = template || "";
  const regex = /\*([^*]+)\*/g;
  const parts = [];
  const correctWords = [];

  let cursor = 0;
  let blankIndex = 0;
  let match;

  while ((match = regex.exec(t)) !== null) {
    const full = match[0];
    const word = (match[1] || "").trim();
    const index = match.index || 0;

    if (index > cursor) {
      parts.push({ type: "text", value: t.slice(cursor, index) });
    }

    if (word) {
      correctWords.push(word);
      parts.push({ type: "blank", blankIndex });
      blankIndex += 1;
    } else {
      parts.push({ type: "text", value: full });
    }

    cursor = index + full.length;
  }

  if (cursor < t.length) {
    parts.push({ type: "text", value: t.slice(cursor) });
  }
  if (parts.length === 0) {
    parts.push({ type: "text", value: t });
  }

  return { parts, correctWords };
}

export function getWordBankCorrectWords(interaction) {
  if (interaction.correctWords && interaction.correctWords.length > 0) {
    return interaction.correctWords;
  }
  return parseWordBankTemplate(interaction.sentenceTemplate).correctWords;
}

// Full word pool shown as chips: correct words first, then distractors.
export function getWordBankPool(interaction) {
  return [...getWordBankCorrectWords(interaction), ...(interaction.distractorWords || [])];
}

export function getMultipleChoiceCorrectIndexes(interaction) {
  return interaction.options
    .map((opt, idx) => (opt.isCorrect ? idx : -1))
    .filter((idx) => idx >= 0);
}

// Fisher–Yates option shuffling.
export function shuffleIndexes(length) {
  const indexes = Array.from({ length }, (_, i) => i);
  for (let i = indexes.length - 1; i > 0; i -= 1) {
    const j = Math.floor(Math.random() * (i + 1));
    [indexes[i], indexes[j]] = [indexes[j], indexes[i]];
  }
  return indexes;
}
